export default function Logo({ size = "md", showText = false }) {
  const heights = { sm: "h-12", md: "h-16", lg: "h-24", xl: "h-36" };
  return (
    <div className="flex items-center select-none" data-testid="brand-logo">
      <img
        src="/btt-logo.png"
        alt="Beyond The Table"
        className={`${heights[size] || heights.md} w-auto object-contain`}
        draggable={false}
      />
    </div>
  );
}
